import { createFileRoute } from '@tanstack/react-router';
import { JourneysNewImportHandoff } from '@/pages/workspaces/imports/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';
import { validateNewImportSearch } from './-new-import-search';

/**
 * The legacy upload URL. Flag off the embedded app renders; flag on it forwards to `/imports/new`,
 * carrying the query string, since the segment and object pages seed the type through it.
 */
function JourneysNewImportRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysNewImportHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/imports/new')({
  validateSearch: validateNewImportSearch,
  component: JourneysNewImportRoute,
});
